module.exports = __webpack_public_path__ + "media/photo/tech_man-294faaee.png";